import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppConditionRentingAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        label="Condition renting alert"
        placeholder="Select condition rating alert"
        urlAjax={`${BACKEND_APIS.CRUD}/user/rating?selectorFormat=true`}
        {...props}
    />
}